<p-table
  cxDragScroll
  showGridlines
  [value]="products()"
  [columns]="columns()"
  [scrollable]="true"
  [reorderableColumns]="true"
  [tableStyle]="{ width: '100%' }"
  (onColReorder)="onColReorder($event)"
>
  <ng-template #header let-columns>
    <tr>
      <th cxFrozenColumn colspan="2">{{ 'product.title' | translate }}</th>

      @for (col of columns; track col.field) {
        <th pReorderableColumn [style.cursor]="allLoaded ? 'pointer' : 'wait'" (click)="onOrderProduct(col, $event)">
          {{ col.field === PRODUCT_LIST_FIELD.INVOICE_AMOUNT ? invoiceAmountLabel() : col.label }}
          @if (sortField() === col.field) {
            <span class="ms-1">{{ sortOrder() === 'asc' ? '↑' : '↓' }}</span>
          }
        </th>
      }
    </tr>
  </ng-template>

  <ng-template #body let-product let-columns="columns" let-index="rowIndex">
    <tr [pReorderableRow]="index" (click)="openProductCardModal(product)">
      <td class="text-wrap" cxFrozenColumn>
        @let media =
          {
            src: product?.medias?.images[0]?.thumbnail?.src,
            altText: product?.medias?.images[0]?.thumbnail?.altText,
          };

        <cx-media [media]="media" (mediaError)="onImageError($event)" />
      </td>

      <td cxFrozenColumn>{{ product.description }}</td>

      @for (col of columns; track col.field) {
        <td>
          @if (col.field === PRODUCT_LIST_FIELD.QUANTITY) {
            <input
              type="number"
              inputmode="numeric"
              min="0"
              class="form-control p-0 text-center"
              title="Quantidade"
              [value]="quantities()[product.code]"
              (click)="$event.stopPropagation()"
            />
          } @else if (col.field === PRODUCT_LIST_FIELD.IN_STOCK) {
            <div class="d-flex justify-content-center">
              @if (!alreadyLoadingStock[product.code]) {
                <skeleton-loading class="loading loading-stock" />
              } @else {
                <product-stock [has]="product[col.field]" />
              }
            </div>
          } @else if (col.field === PRODUCT_LIST_FIELD.DELIVERY_TIME) {
            @if (!alreadyLoadingDeliveryTime[product.code]) {
              <skeleton-loading class="loading loading-delivery-time" />
            } @else {
              {{ product[col.field] }}
            }
          } @else if (col.field === PRODUCT_LIST_FIELD.INVOICE_AMOUNT) {
            @if (!alreadyLoadingPrice[product.code]) {
              <skeleton-loading class="loading loading-delivery-time" />
            } @else {
              <span class="text-primary">
                {{ product[col.field] }}
              </span>
            }
          } @else if (col.field === PRODUCT_LIST_FIELD.FACTORY_PRICE) {
            @if (!alreadyLoadingPrice[product.code]) {
              <skeleton-loading class="loading loading-delivery-time" />
            } @else {
              <span class="text-primary">
                {{ product[col.field] }}
              </span>
            }
          } @else if (col.field === PRODUCT_LIST_FIELD.COMPANY) {
            <div class="d-flex justify-content-center">
              @if (!alreadyLoadingStock[product.code]) {
                <skeleton-loading class="loading loading-company" />
              } @else {
                <cx-media [media]="{ src: getBrandLogo(product[col.field]) }" />
              }
            </div>
          } @else if (col.field === PRODUCT_LIST_FIELD.CUT_OFF_TIME) {
            <div class="d-flex justify-content-center">
              @if (!alreadyLoadingDeliveryTime[product.code]) {
                <skeleton-loading class="loading loading-cut-off-time" />
              } @else {
                <span class="text-primary">
                  {{ product[col.field] }}
                </span>
              }
            </div>
          } @else {
            {{ product[col.field] }}
          }
        </td>
      }
    </tr>
  </ng-template>
</p-table>
